import get from 'lodash/get';
import { GET_PRICES_LANDING, GET_PRICES_COMPARES } from '../constants/prices';

const DEFAULT_STATE = {
  kpis: [],
  filters: [],
  landing: [],
  landing_detail: [],
  compares: [],
  evolution: [],
  evolutionN: {
    filters: { wines: [], networks: [] },
    data: {}
  }
};

export default (state = DEFAULT_STATE, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case GET_PRICES_LANDING:
      return {
        ...state,
        landing: get(payload, 'data', []),
        landing_detail: get(payload, 'data_detail', []),
        filters: get(payload, 'filters', []),
        kpis: get(payload, 'kpis', []),
        rivals_vintages: get(payload, 'rivals_vintages', []),
        is_champaign: get(payload, 'is_champaign', true)
      };
    case GET_PRICES_COMPARES:
      return { ...state, compares: get(payload, 'data', []) };
    default:
      return state;
  }
};
